const colors = {
  vermilion: "#FF4C00",
  darkVermilion: "#D7480F",
  lightVermilion: "#FF7033",
  tangaroa: "#04143A",
  lightTangaroa: "#364361",
  midTangaroa: "#9199a7",
  darkTangaroa: "#0E1C3D",
  blue: "#337FF2",
  green: "#4BA695",
  fernGreen: "#3E7934",
  orange: "#fc8b47",
  tahitiGold: "#DB5C2A",
  red: "#A80F13",
  black: "#383D4A",
  transparentBlack: "rgba(56, 61, 74, 0.8)",
  grayDark: "#666666",
  grayMed: "#A6A6A6",
  grayMedLight: "#E6E6E6",
  grayLight: "#f5f5f5",
  whiteBlue: "#FBFDFF",
  whiteGray: "#FBFBFB",
  white: "#FFFFFF",
  opaqueTangaroa: "rgba(4, 20, 58, .15)",
};

export default colors;
